import {
  GraduationCap,
  Sparkles,
  Award,
  Zap,
  Globe,
  Briefcase,
  Rocket,
 
  Heart,
  Cpu,
  TrendingUp,
 
  HandCoins,
  Handshake,
  Network,
  Target,
  Eye,
} from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import { motion } from "framer-motion";
import BlockAcademicOffer from "../../components/BlockAcademicOffer";
 

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/61852126-e432-4e54-ad68-3608ee99cbd4" +
  "?include=field_imagen_portada.field_media_image,field_imagen21.field_media_image,field_imagen22.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_imagen21,field_imagen22,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6," +
  "field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,,field_bloque15,,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22," +
  "field_bloque23,field_bloque24,field_bloque25" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function DecideSerMas() {
  const blockStyles = `
    bg-white rounded-2xl p-8 shadow-lg
    hover:-translate-y-1 transition-all duration-300

    [&_h3]:text-4xl
    [&_h3]:font-black
    [&_h3]:text-[#004270]
    [&_h3]:leading-none
    [&_h3]:mb-4

    [&_h4]:text-2xl
    [&_h4]:font-bold
    [&_h4]:text-[#004270]
    [&_h4]:mb-3

    [&_p]:text-slate-600
    [&_p]:leading-7
    [&_p_strong]:text-[#004270]
    [&_p_strong]:font-semibold
  `;

  const DataDisplay = ({ data }) => {
    if (!data) return null;

    const testimoniosPrendho = [
      {
        content: data.bloque16,
      },
      {
        content: data.bloque17,
      },
      {
        content: data.bloque18,
      },
      {
        content: data.bloque19,
      },
      {
        content: data.bloque20,
      },
    ];

    const bloques = [
      { content: data.bloque1, icon: Award },
      { content: data.bloque2, icon: Zap },
      { content: data.bloque3, icon: GraduationCap },
      { content: data.bloque4, icon: Globe },
      { content: data.bloque5, icon: Briefcase },
      { content: data.bloque6, icon: Rocket },
    ];

    const lineasEstrategicas = [
      {
        id: 1,
        content: data.bloque8,
        icon: Heart,
        color: "from-blue-500 to-indigo-600",
      },
      {
        id: 2,
        content: data.bloque9,
        icon: Cpu,
        color: "from-amber-500 to-yellow-600",
      },
      {
        id: 3,
        content: data.bloque10,
        icon: Globe,
        color: "from-emerald-500 to-teal-600",
      },
      {
        id: 4,
        content: data.bloque11,
        icon: TrendingUp,
        color: "from-cyan-500 to-blue-600",
      },
    ];
    return (
      <div>
        {/* HERO */}
        <section>
          <div className="relative overflow-hidden pt-12 pb-24 lg:pt-20 lg:pb-32 bg-gradient-to-br from-white via-slate-50 to-[#004270]/5">
            <div className="absolute inset-0 opacity-40 pointer-events-none">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern
                    id="hero-grid"
                    width="40"
                    height="40"
                    patternUnits="userSpaceOnUse"
                  >
                    <path
                      d="M 40 0 L 0 0 0 40"
                      fill="none"
                      stroke="rgba(0,66,112,0.06)"
                      strokeWidth="1"
                    />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#hero-grid)" />
              </svg>
            </div>

            <div className="max-w-7xl mx-auto px-4 relative z-10">
              <div className="max-w-5xl m-auto text-center space-y-8 mt-10">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="flex items-center justify-center gap-2 text-[#015e9e] font-semibold text-sm uppercase"
                >
                  <Sparkles className="w-4 h-4 text-[#febe10]" />
                  <span>La Universidad más Innovadora del Ecuador</span>
                </motion.div>

                <div
                  className="
                    [&_h2]:text-5xl [&_h2]:font-extrabold [&_h2]:text-[#004270] [&_h2]:text-center
                    [&_h3]:text-6xl [&_h3]:font-black [&_h3]:text-center
                    [&_h3]:bg-gradient-to-r [&_h3]:from-[#004270] [&_h3]:via-[#015e9e] [&_h3]:to-[#febe10]
                    [&_h3]:bg-clip-text [&_h3]:text-transparent [&_h3]:m-0 [&_h3]:p-0 [&_h3]:pb-10
                    [&_p]:text-center [&_p]:max-w-3xl [&_p]:mx-auto
                    [&_p]:text-slate-500 [&_p]:leading-7

                     [&_h4]:inline-flex
    [&_h4]:items-center
    [&_h4]:justify-center
    [&_h4]:rounded-full
    [&_h4]:bg-[#febe10]
    [&_h4]:px-4
    [&_h4]:py-2
    [&_h4]:text-xs
    [&_h4]:font-bold
    [&_h4]:uppercase
    [&_h4]:tracking-wider
    [&_h4]:text-[#004270]
    [&_h4]:shadow-lg
    [&_h4]:border-2
    [&_h4]:border-white
    [&_h4]:mx-1
    [&_h4]:mb-4 [&_h4]:mt-10
                  "
                  dangerouslySetInnerHTML={{ __html: data.texto_portada }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* BLOQUES */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {bloques.map(({ content, icon: Icon }, index) => (
              <div key={index} className="group relative">
                <div className="absolute left-1/2 -translate-x-1/2 -top-7 z-10">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#febe10] to-[#ffd84d] flex items-center justify-center shadow-lg">
                    <Icon className="w-8 h-8 text-[#004270]" />
                  </div>
                </div>

                <div
                  className={`${blockStyles} pt-14 h-full border border-slate-100 text-center pb-10`}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            ))}
          </div>
        </section>

        <section
          id="pilares"
          className="py-24 bg-gradient-to-b from-slate-50 to-white"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="text-center space-y-4 max-w-3xl mx-auto">
              <h2 className="text-xs font-black uppercase tracking-widest text-[#febe10]">
                Líneas estratégicas, misionalidad y visión
              </h2>
              <div
                className="
                  

                    [&_h3]:text-6xl [&_h3]:font-black [&_h3]:text-center
                    [&_h3]:bg-gradient-to-r [&_h3]:from-[#004270] [&_h3]:via-[#015e9e] [&_h3]:to-[#febe10]
                    [&_h3]:bg-clip-text [&_h3]:text-transparent [&_h3]:m-0 [&_h3]:p-0 [&_h3]:pb-10
                    [&_p]:text-center [&_p]:max-w-3xl [&_p]:mx-auto
                    [&_p]:text-slate-500 [&_p]:leading-7
                  "
                dangerouslySetInnerHTML={{ __html: data.bloque7 }}
              />
            </div>

            {/* Pillars Cards Grid */}
            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8 mt-16">
              {lineasEstrategicas.map((pilar, index) => {
                const Icon = pilar.icon;

                return (
                  <motion.div
                    key={pilar.id}
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.15 }}
                    viewport={{ once: true }}
                    whileHover={{
                      y: -10,
                      scale: 1.03,
                    }}
                    className="relative bg-white rounded-3xl p-8 shadow-lg overflow-hidden group"
                  >
                    <span className="absolute top-6 right-6 text-6xl font-black text-slate-100">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#004270] to-[#015e9e] flex items-center justify-center mb-6 shadow-lg">
                      <Icon className="w-8 h-8 text-white" />
                    </div>

                    <div
                      className="
            relative z-10
            [&_h4]:text-[#004270]
            [&_h4]:font-bold
            [&_h4]:text-2xl
       
            [&_p]:text-slate-600
            [&_p]:leading-7
          "
                      dangerouslySetInnerHTML={{ __html: pilar.content }}
                    />

                    <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#febe10] group-hover:w-full transition-all duration-500" />
                  </motion.div>
                );
              })}
            </div>

            {/* Misión y Visión */}
            <div className="grid lg:grid-cols-2 gap-10 mt-20">
              {/* MISIÓN */}
              <motion.div
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                whileHover={{ y: -8 }}
                className="relative overflow-hidden rounded-3xl bg-[#004270] p-10 shadow-2xl"
              >
                {/* Decoración */}
                <div className="absolute -right-16 -top-16 w-52 h-52 rounded-full bg-white/10 blur-3xl" />

                <div className="relative z-10">
                  <div className="mb-8 flex items-center gap-4">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 backdrop-blur">
                      <Target className="h-8 w-8 text-[#febe10]" />
                    </div>

                    <span className="text-sm font-bold uppercase tracking-[0.3em] text-[#febe10]">
                      Misión
                    </span>
                  </div>

                  <div
                    className="
          [&_h2]:hidden
          [&_p]:text-white
          [&_p]:text-lg
          [&_p]:leading-8
        "
                    dangerouslySetInnerHTML={{ __html: data.bloque12 }}
                  />
                </div>
              </motion.div>

              {/* VISIÓN */}
              <motion.div
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                whileHover={{ y: -8 }}
                className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-10 shadow-xl"
              >
                {/* Decoración */}
                <div className="absolute -right-16 -bottom-16 w-56 h-56 rounded-full  blur-3xl" />

                <div className="relative z-10">
                  <div className="mb-8 flex items-center gap-4">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#004270]/10">
                      <Eye className="h-8 w-8 text-[#004270]" />
                    </div>

                    <span className="text-sm font-bold uppercase tracking-[0.3em] text-[#004270]">
                      Visión
                    </span>
                  </div>

                  <div
                    className="
          [&_h2]:hidden
          [&_p]:text-slate-600
          [&_p]:text-lg
          [&_p]:leading-8
        "
                    dangerouslySetInnerHTML={{ __html: data.bloque13 }}
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        <section>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
              className="[&_p]:text-slate-600 max-w-4xl m-auto text-center  "
              dangerouslySetInnerHTML={{ __html: data.bloque14 }}
            />
          </div>

          <div className="[&_h2]:hidden [&_h3]:hidden [&_p]:hidden">
            <BlockAcademicOffer></BlockAcademicOffer>{" "}
          </div>
        </section>

        {/* INNOVATION & SUSTAINABLE CAMPUS GRID */}
        <section id="innovacion" className="py-24 bg-slate-50 mt-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="text-center space-y-4 max-w-3xl mx-auto mb-16">
              <h2 className="text-xs font-black uppercase tracking-widest text-[#febe10]">
                Liderazgo & Ecosistema
              </h2>
              <div
                className="[&_p]:text-slate-600 max-w-4xl m-auto text-center  "
                dangerouslySetInnerHTML={{ __html: data.bloque15 }}
              />
            </div>

            {/* Grid Cards of Innovations */}
            <div className="grid lg:grid-cols-3 gap-8">
              {testimoniosPrendho.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-white border border-slate-100 rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between group"
                >
                  <div className="space-y-4">
                    <div
                      className="
    [&_h4]:inline-block
    [&_h4]:w-fit
    [&_h4]:rounded-full
    [&_h4]:bg-yellow-300
    [&_h4]:px-3
    [&_h4]:py-1
    [&_h4]:text-xs
    [&_h4]:font-semibold
    [&_h4]:uppercase
    [&_h4]:tracking-wide
    [&_h4]:text-slate-900

    [&_h2]:mt-4
    [&_h2]:text-4xl
    [&_h2]:font-bold
    [&_h2]:leading-tight

    [&_p]:mt-3
    [&_p]:text-lg
    [&_p]:text-slate-600

    [&_h3]:inline-flex
    [&_h3]:items-center
    [&_h3]:rounded-lg
    [&_h3]:bg-slate-100
    [&_h3]:px-4
    [&_h3]:py-2
    [&_h3]:font-medium
     [&_h3]:text-sm
         [&_h3]:my-2
  "
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-16 items-center">
            {/* Imagen */}
            <motion.div
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="relative"
            >
              <img
                src={data.imagen21}
                alt="Vinculación"
                className="rounded-3xl shadow-2xl w-full object-cover"
              />

              <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-2xl bg-[#004270] shadow-xl flex items-center justify-center">
                <Network size={42} className="text-white" />
              </div>
            </motion.div>

            {/* Contenido */}
            <motion.div
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="
        [&_h2]:text-4xl
        [&_h2]:font-bold
        [&_h2]:text-[#004270]
        [&_h2]:mb-6
        [&_p]:text-lg
        [&_p]:leading-8
        [&_p]:text-gray-700
        [&_ul]:space-y-3
        [&_li]:text-gray-700
      "
            >
          

              <div dangerouslySetInnerHTML={{ __html: data.bloque21 }} />
            </motion.div>
          </div>
        </section>

        <section className="bg-[#004270] py-20 overflow-hidden">
          {/* Encabezado */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="max-w-7xl mx-auto px-4 text-center text-white mb-14
      [&_h2]:text-4xl
      [&_h2]:font-bold
      [&_h2]:mb-4
      [&_h2]:text-white
      [&_p]:text-lg
      [&_p]:opacity-90"
            dangerouslySetInnerHTML={{ __html: data.bloque22 }}
          />

          {/* Tarjetas */}
          <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Apoyo financiero */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, scale: 1.03 }}
              className="bg-white rounded-2xl p-8 shadow-xl h-full"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#004270]/10 flex items-center justify-center">
                <HandCoins size={42} className="text-[#004270]" />
              </div>

              <div
                className="
          [&_h2]:text-[#004270]
          [&_h2]:text-2xl
          [&_h2]:font-bold
          [&_h2]:mb-4
          [&_p]:text-[#004270]
          [&_p]:leading-relaxed"
                dangerouslySetInnerHTML={{ __html: data.bloque23 }}
              />
            </motion.div>

            {/* Alianzas */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, scale: 1.03 }}
              className="bg-white rounded-2xl p-8 shadow-xl   h-full"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#004270]/10 flex items-center justify-center">
                <Handshake size={42} className="text-[#004270]" />
              </div>

              <div
                className="
          [&_h2]:text-[#004270]
          [&_h2]:text-2xl
          [&_h2]:font-bold
          [&_h2]:mb-4
          [&_p]:text-[#004270]
          [&_p]:leading-relaxed"
                dangerouslySetInnerHTML={{ __html: data.bloque24 }}
              />
            </motion.div>

            {/* Formación integral */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, scale: 1.03 }}
              className="bg-white rounded-2xl p-8 shadow-xl h-full"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#004270]/10 flex items-center justify-center">
                <GraduationCap size={42} className="text-[#004270]" />
              </div>

              <div
                className="
          [&_h2]:text-[#004270]
          [&_h2]:text-2xl
          [&_h2]:font-bold
          [&_h2]:mb-4
          [&_p]:text-[#004270]
          [&_p]:leading-relaxed"
                dangerouslySetInnerHTML={{ __html: data.bloque25 }}
              />
            </motion.div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default DecideSerMas;
